"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictionaryActionbar = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const Check_1 = __importDefault(require("@material-ui/icons/Check"));
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const detail_action_button_1 = require("../../action-button/detail/detail-action-button");
const detail_actionbar_button_1 = require("../../detail/detail-actionbar-button");
const detail_context_1 = require("../../detail/detail-context");
const detail_types_1 = require("../../detail/detail-types");
const invalidate_hook_1 = require("./dialog-actions/invalidate-hook");
const revalidate_hook_1 = require("./dialog-actions/revalidate-hook");
const useStyles = (0, makeStyles_1.default)(() => ({
    wrapper: {
        flexWrap: 'wrap',
    },
}));
function DictionaryActionbar({ Before, After, }) {
    const classes = useStyles();
    const { mode, source } = (0, react_1.useContext)(detail_context_1.DetailContext);
    const intl = (0, react_intl_1.useIntl)();
    const { callApi: revalidateApiCall, showButton: showRevalidateButton } = (0, revalidate_hook_1.useRevalidateDialog)(source.url);
    const { callApi: invalidateApiCall, showButton: showInvalidateButton } = (0, invalidate_hook_1.useInvalidateDialog)(source.url);
    return (react_1.default.createElement(react_1.default.Fragment, null, mode === detail_types_1.DetailMode.VIEW && (react_1.default.createElement("div", { className: classes.wrapper },
        !!Before && react_1.default.createElement(Before, null),
        showRevalidateButton && (react_1.default.createElement(detail_action_button_1.DetailActionButton, { promptKey: "REVALIDATE", apiCall: revalidateApiCall, buttonLabel: intl.formatMessage({
                id: 'ES__DICTIONARY__ACTIONBAR__REVALIDATE',
                defaultMessage: 'Obnovit platnost',
            }), dialogTitle: intl.formatMessage({
                id: 'ES__DICTIONARY__DIALOG_REVALIDATE__TITLE',
                defaultMessage: 'Varování',
            }), dialogText: intl.formatMessage({
                id: 'ES__DICTIONARY__DIALOG_REVALIDATE__TEXT',
                defaultMessage: 'Opravdu chcete obnovit platnost záznamu?',
            }), ButtonComponent: detail_actionbar_button_1.PrimaryDetailActionbarButton, buttonProps: {
                startIcon: react_1.default.createElement(Check_1.default, null),
            } })),
        showInvalidateButton && (react_1.default.createElement(detail_action_button_1.DetailActionButton, { promptKey: "INVALIDATE", apiCall: invalidateApiCall, buttonLabel: intl.formatMessage({
                id: 'ES__DICTIONARY__ACTIONBAR__INVALIDATE',
                defaultMessage: 'Zneplatnit',
            }), dialogTitle: intl.formatMessage({
                id: 'ES__DICTIONARY__DIALOG_INVALIDATE__TITLE',
                defaultMessage: 'Varování',
            }), dialogText: intl.formatMessage({
                id: 'ES__DICTIONARY__DIALOG_INVALIDATE__TEXT',
                defaultMessage: 'Opravdu chcete zneplatnit záznam?',
            }), ButtonComponent: detail_actionbar_button_1.SecondaryDetailActionbarButton, buttonProps: {
                startIcon: react_1.default.createElement(Close_1.default, null),
            } })),
        !!After && react_1.default.createElement(After, null)))));
}
exports.DictionaryActionbar = DictionaryActionbar;
//# sourceMappingURL=dictionary-actionbar.js.map